import React from 'react'
import { object, any } from 'prop-types'
import { Grid } from '@mui/material'
const AdaptativeGridContainer = ({ children, sx, ...props }) => {
  return (
    <Grid
      {...props}
      container
      columnSpacing={{ xs: 0, md: 2, lg: 3 }}
      sx={{
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'flex-start',
        padding: { xs: '0 1rem', md: '0' },
        '& .MuiGrid-item': {
          paddingLeft: '0px'
        },

        ...sx,
        //  '& .MuiGrid-container': {
        //   width: '100%!important',
        //   marginLeft: '0px',
        //   background: 'red!important'
        // },
        // background: 'red',
        width: '100%!important',
        marginLeft: '0px!important'
      }}
    >
      {children}
    </Grid>
  )
}

AdaptativeGridContainer.propTypes = {
  children: any,
  sx: object
}

export default AdaptativeGridContainer
